import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import Filter from 'badwords-ko';

const ChatMessage = (props) => {
  //console.log(props);
  const writetime = moment(new Date()).format('HH:mm');
  // const currentTime = new Date().toLocaleTimeString();
  const customFilter = new Filter({ placeHolder: ' ' });
  //console.log(props.childProps.message);
  let message;
  if (props.childProps.bot) {
    message = props.childProps.message;
  } else {
    if (typeof props.childProps.message === 'object') {
    } else {
      message = customFilter.clean(props.childProps.message);
    }
  }

  return (
    <div className="ir-chat-contaner">
      <div
        className={
          props.childProps.bot ? 'ri-chat-message-bot' : 'ri-chat-message-user'
        }
      >
        {message}
      </div>
      <div className="ri-chat-time-right">{writetime}</div>
    </div>
  );
};

export default shopContext(withRouter(ChatMessage));
// export default ChatMessage;
